import React from "react";
import { Button, Checkbox, CheckboxGroup, Flex, Input, Stack } from "@chakra-ui/react";
import { ONE, ZERO } from "../../../App";

type FormProps = {
	selectedSmiley: number;
	values: string[]
	setValues: (values: string[]) => void;
	inputValue: string | undefined;
	setInputValue: (value: string) => void;
	saveInFirebase: () => void;
};

export const Form = ({
	selectedSmiley,
	values,
	setValues,
	inputValue,
	setInputValue,
	saveInFirebase
}: FormProps) => {
	const TWO = 2;
	const THREE = 3;

	const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value;
		if (values.includes(value)) {
			const newArray = values.filter(e => e !== value);
			setValues(newArray);
		} else {
			setValues([...values, value]);
		}
	};

	const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setInputValue(event.target.value);
	};

	return (
		<Flex direction="column" gap="12px">
			<CheckboxGroup value={values} colorScheme="blue">
				{selectedSmiley === ONE && <Stack>
					<Checkbox onChange={onChange}
							  value="Navigation">
						Navigation
					</Checkbox>
					<Checkbox onChange={onChange}
							  value="Lay-Out">
						Lay-Out
					</Checkbox>
					<Checkbox onChange={onChange} value="Contents">
						Contents
					</Checkbox>
					<Checkbox onChange={onChange} value="Readability">
						Readability
					</Checkbox>
					<Checkbox onChange={onChange} value="Mobile / Tablet experience">
						Mobile / Tablet experience
					</Checkbox>
					<Checkbox onChange={onChange} value="Out of date (content)">
						Out of date (content)
					</Checkbox>
					<Checkbox onChange={onChange} value="Technical issues">
						Technical issues
					</Checkbox>
					<Checkbox onChange={onChange} value="Animations / Distraction">
						Animations / Distraction
					</Checkbox>
					<Flex gap="8px">
						<Checkbox onChange={onChange} value={inputValue}/>
						<Input
							placeholder={"Other..."}
							size="sm"
							value={inputValue}
							onChange={handleInputChange}/>
					</Flex>
				</Stack>
				}
				{selectedSmiley === TWO && <Stack>
					<Checkbox onChange={onChange} value="Engaging content (text)">Engaging content
						(text)</Checkbox>
					<Checkbox onChange={onChange} value="Clear instructions">Clear
						instructions</Checkbox>
					<Checkbox onChange={onChange} value="Navigation">Navigation</Checkbox>
					<Checkbox onChange={onChange} value="Lay-out">Lay-out</Checkbox>
					<Checkbox onChange={onChange} value="Contents">Contents</Checkbox>
					<Checkbox onChange={onChange} value="Readability">Readability</Checkbox>
					<Checkbox onChange={onChange} value="Mobile / Tablet experience">Mobile / Tablet
						experience</Checkbox>
					<Checkbox onChange={onChange} value="Technical issues">Technical
						issues</Checkbox>
					<Checkbox onChange={onChange} value="Animations / Distraction">Animations /
						Distraction</Checkbox>
					<Flex gap="8px">
						<Checkbox onChange={onChange} value={inputValue}/>
						<Input
							placeholder={"Other..."}
							size="sm"
							value={inputValue}
							onChange={handleInputChange}/>
					</Flex>
				</Stack>
				}
				{selectedSmiley === THREE && <Stack>
					<Checkbox onChange={onChange} value="Engaging content (text)">Engaging content
						(text)</Checkbox>
					<Checkbox onChange={onChange} value="Clear instructions">Clear
						instructions</Checkbox>
					<Checkbox onChange={onChange} value="Well-structured">Well-structured</Checkbox>
					<Checkbox onChange={onChange} value="Lay-out">Lay-out</Checkbox>
					<Checkbox onChange={onChange} value="Appealing / attractive">Appealing /
						attractive</Checkbox>
					<Checkbox onChange={onChange} value="Mobile / Tablet experience">Mobile / Tablet
						experience</Checkbox>
					<Flex gap="8px">
						<Checkbox onChange={onChange} value={inputValue}/>
						<Input
							placeholder={"Other..."}
							size="sm"
							value={inputValue}
							onChange={handleInputChange}/>
					</Flex>
				</Stack>
				}
				<Button
					fontFamily="Proxima-Nova"
					bgColor="rgb(0, 177, 255)"
					color="white"
					fontSize="15px"
					fontWeight="500"
					_hover={{
						bgColor: "rgb(0,147,205)"
					}}
					_active={{
						bgColor: "rgb(0,177,235)"
					}}
					disabled={values.length === ZERO && !inputValue}
					onClick={() => saveInFirebase()}
				>Send Feedback</Button>
			</CheckboxGroup>
		</Flex>
	);
};

export default Form;